import {LOADER_ACTIONS} from "../actions/types";

export default (state = 0, {type}) => {
	switch (type) {
		case LOADER_ACTIONS.ADD:
			return state + 1;
		case LOADER_ACTIONS.REMOVE:
			return Math.max(0, state - 1);
		case LOADER_ACTIONS.CLEAR_ALL:
			return 0;
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/loaderReducer.js